import React, { type FC, useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Unauthorized from "src/components/Pages/Unauthorized/Unauthorized";
import { renewMidwayTokenOrRedirect } from "src/midway/MidwayConnector";
import { isPayeeCentral, isStandalone } from "../api/config";
import InboundDocument from "./Pages/DocumentInbound";
import DocumentListing from "./Pages/DocumentList";
import Nest from "./Pages/Nest";
import PageNotFound from "./Pages/NotFound/PageNotFound";
import { setPayeeIntegrationCookie } from "src/cookies";

export const DocumentListingRootPath = "/";
export const UnauthorizedPagePath = "/unauthorized";
export const DocumentListingInboundCentralPath = "/inbound-central";
export const DocumentListingIndexExternalPath =
  "/inbound-central/index-external.html";
export const DocumentListingIndexInternalPath =
  "/inbound-central/index-internal.html";
export const InboundDocumentPath =
  "/inbound-central/countries/:countryCode/document-types/:documentType/documents/:documentId";
export const InboundDocumentPathWithInboundDocumentTab =
  "/inbound-central/countries/:countryCode/document-types/:documentType/documents/:documentId/:inboundDocumentTab";
export const NestPath = "/inbound-central/nest";

const router = createBrowserRouter([
  { path: NestPath, element: <Nest /> },
  { path: DocumentListingRootPath, element: <DocumentListing /> },
  { path: DocumentListingIndexExternalPath, element: <DocumentListing /> },
  { path: DocumentListingIndexInternalPath, element: <DocumentListing /> },
  { path: InboundDocumentPath, element: <InboundDocument /> },
  {
    path: InboundDocumentPathWithInboundDocumentTab,
    element: <InboundDocument />,
  },
  { path: DocumentListingInboundCentralPath, element: <DocumentListing /> },
  { path: UnauthorizedPagePath, element: <Unauthorized /> },
  { path: "*", element: <PageNotFound /> },
]);

export const App: FC = () => {
  useMemo(() => {
    if (isPayeeCentral()) {
      setPayeeIntegrationCookie();
    } else if (isStandalone()) {
      renewMidwayTokenOrRedirect();
    }
  }, []);

  return <RouterProvider router={router} />;
};
